import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ui-nested-table',
  templateUrl: './ui-nested-table.component.html',
  styleUrls: ['./ui-nested-table.component.scss']
})
export class UiNestedTableComponent implements OnInit {

  constructor() { }

  @Input() parentTableHeader: any[] = [];
  @Input() parentTableData: any[] = [];
  @Input() childTableHeader: any[] = [];
  @Input() childTableData: any[] = [];

  ngOnInit(): void {
    /* Fill Dummy Data IF no data has been passed */
    if(!this.parentTableData.length) this.dummyDataFill('parentTableData');
    if(!this.childTableData.length) this.dummyDataFill('childTableData');
    if(!this.parentTableHeader.length) this.dummyDataFill('parentTableHeader');
    if(!this.childTableHeader.length) this.dummyDataFill('childTableHeader');
  }

  dummyDataFill(name:string='parent') {
    if('parentTableData'==name){
      for (let i = 0; i < 3; ++i) {
        this.parentTableData.push({
          expanded: false,
          key: i,
          name: 'Fort Speciality',
          details: 'Partner Hosp.',
          address: 'Grand Trunk Road, Marine Drive, KD 2910',
          doa: '12 Jan 2019',
          dod: '15 Jan 2019',
        });
      }
    }
    if('childTableData'==name) {
      for (let i = 0; i < 3; ++i) {
        this.childTableData.push({
          key: i,
          name: 'Dr. John Dorian',
          det: 'MD Pathology',
          regDetails: 'RGNF09993883',
          treatedFor: 'Angioplasty',
          remarks: 'No complications',
        });
      }
    }
    if('parentTableHeader'==name){
      this.parentTableHeader = [
        {id: 1, name: "Name of Hospital"},
        {id: 2, name: "Hospital Details"},
        {id: 3, name: "Address"},
        {id: 4, name: "Date of Admission"},
        {id: 5, name: "Date of Discharge"},
        {id: 6, name: "Action"},
      ];
    }
    if('childTableHeader'==name){
      this.childTableHeader = [
        {id: 1, name: "Doctor Name"},
        {id: 1, name: "Details"},
        {id: 1, name: "Regn. Details"},
        {id: 1, name: "Treated For"},
        {id: 1, name: "Remarks"},
      ];
    }

  }

  openHospModal(){
    
  }

}
